<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'交易流水明细':'交易流水明细'" :visible.sync="dialog" @close="unShowClick()" width="50%">
			<el-form :inline='true'>
				<div class="flex flex-b">
					<el-form-item>
						<el-button type="primary" size='mini' @click="exportData('新增')">导出
						</el-button>
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="addBody.staticTimes" @change="staticTimesChange" format='yyyy-MM-dd'
							value-format='yyyy-MM-dd' size='small' type="datetimerange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
				</div>
			</el-form>

			<el-table :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#606266'}" border
				style="width: 100%">
				<el-table-column prop="date" label="购买类型" align="center">
					<template slot-scope="scope">
						{{scope.row.order_type==1?'培训订单':'会员订单'}}
					</template>
				</el-table-column>
				<el-table-column prop="order_id" label="订单编号" align="center">
				</el-table-column>
				<el-table-column prop="name" label="名称" align="center">
				</el-table-column>
				<el-table-column prop="price_cost" label="金额" align="center">
				</el-table-column>
			</el-table>
			
			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>
		</el-dialog>
	</div>
</template>

<script>
	import XLSX from 'xlsx'
	import {
		getBill,
	} from '@/api/statics'
	import {
		getUserList,
	} from '@/api/user'
	import ImageUpload from "@/components/ImageUpload"
	import CommonPagination from "@/components/CommonPagination";
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload,
			CommonPagination
		},
		data() {
			return {
				loading: false,
				options: [],
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					staticTimes: '',
					start_time: '',
					end_time: ''
				},
				images: [],
				roleUuid: "",
				weightList: [],
				weight: '',
				isEdit: false,
				tableData: [],
				total: 0,
				page_size: 10,
				page_index: 1,
			}
		},
		mounted() {
			this.getBill()
		},
		methods: {
			exportData() {
				const headers = ['购买类型', '订单编号', '名称', '金额']
				const data = this.tableData.map(item => [item.order_type==1?'培训订单':'会员订单', item.order_id, item.name, item.price_cost
				])
				const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])
				const workbook = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
				XLSX.writeFile(workbook, '交易流水明细.xlsx')
			},
			handlePageChange(page) {
				this.page_index = page;
				this.getBill();
			},
			handleSizeChange(size) {
				this.page_size = size;
				this.getBill();
			},
			async getBill(){
				const {
					status,
					data
				} = await getBill({
					start_time: this.addBody.start_time,
					end_time: this.addBody.end_time,
					page_index:this.page_index,
					page_size:this.page_size
				});
				if (status !== 200) return;
				this.tableData = data.result.data
				this.total = data.result.total;
			},
			staticTimesChange(e) {
				this.tabPosition = ''
				if (e) {
					this.addBody.start_time = e[0]
					this.addBody.end_time = e[1]
				} else {
					this.addBody.start_time = ''
					this.addBody.end_time = ''
				}
				this.getBill()
			},
			changeUser(e) {
				let opItem = this.options.find(item => {
					return item.uuid = e
				})
				this.addBody.name = opItem.name
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					this.getUserList(query)
				}
			},
			async getUserList(phone) {
				const {
					status,
					data
				} = await getUserList({
					phone: phone
				})
				if (status !== 200) return
				this.options = data.result.data
				this.loading = false
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().addSendScore()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addSendScore: async () => {
						const {
							status,
							data
						} = await addSendScore({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('下发成功')
					},
					editUser: async () => {
						const {
							status
						} = await editUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUser: async (uuid) => {
						const {
							data,
							status
						} = await getUser({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().getUser(val.uuid)
				} else {
					this.addBody.user_uuid = ''
					this.addBody.score = ''
					this.addBody.name = ''
					this.addBody.phone = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>